import { Tooltip } from "@material-ui/core";
import { UserAvatar } from "@ui/UserAvatar";
import { getFullName } from "@clockwise/web-commons/src/util/profile.util";
import React from "react";

type Props = {
  owner: {
    email?: string | null;
    givenName: string | null;
    familyName: string | null;
    externalImageUrl: string | null;
  };
  isOwner?: boolean;
  isReschedule?: boolean;
};

/**
 * Dynamic title for a meeting being booked with a Scheduling Link, including an avatar and a
 * call-out to notify the user if they are looking at their own Link.
 */
export function MeetingTitle({ owner, isOwner = false, isReschedule = false }: Props) {
  const ownerFullName = getFullName(owner);

  const getScheduleWithMessage = () => {
    if (isReschedule) {
      return "Reschedule with";
    }
    return isOwner ? "Book with" : "You and";
  };

  return (
    <div className="cw-flex cw-items-center cw-py-1 cw-overflow-hidden cw-break-words cw-text-slate-standard cw-gap-4">
      <UserAvatar profile={owner} size="large" cw-id="link-avatar" aria-label="link owner avatar" />
      <div className="cw-flex cw-flex-col cw-gap-[2px] cw-font-body">
        <div>
          <span className="cw-text-14">{getScheduleWithMessage()} </span>
          <span className="cw-font-bold" cw-id="link-owner-name" aria-label="link owner name">
            {ownerFullName}
          </span>
        </div>
        {isOwner && !!owner.email && (
          <span className="cw-text-green cw-text-14 cw-underline cw-decoration-dotted cw-leading-tight cw-cursor-default">
            <Tooltip
              disableFocusListener
              title={
                <span>
                  You are logged in as {owner.email}. To view exactly what recipients will see, try
                  opening this link in an incognito window.
                </span>
              }
              arrow
              placement="bottom-start"
              classes={{
                popper: "cw-max-w-[200px] cw-absolute -cw-ml-12",
                tooltip: "cw-bg-[#555555]/[.99] cw-p-3",
                tooltipPlacementBottom: "cw-top-1",
              }}
            >
              <span>That's you!</span>
            </Tooltip>
          </span>
        )}
      </div>
    </div>
  );
}
